const VICTORY_PARTICLES = Array.from({ length: 18 }, (_, index) => index);

function GameOverlay({
  status,
  gameTitle = 'Arcade Shooter',
  score,
  levelName,
  levelIndex = 0,
  levelCount = 0,
  challengeSummary,
  runSummary,
  levelAdvanceSeconds,
  onStartGame,
  onStartNextLevel,
  onStartPracticeLevel,
  practiceMode = false,
  restartLevelName,
  onReturnToLibrary,
}) {
  return (
    <div className={`game-overlay game-overlay-${status}`}>
      {status === 'won' && (
        <div className="victory-celebration" aria-hidden="true">
          <span className="victory-ring" />
          {VICTORY_PARTICLES.map((particle) => (
            <span
              className="victory-particle"
              key={particle}
              style={{
                '--particle-index': particle,
              }}
            />
          ))}
        </div>
      )}
      <div className={`overlay-panel overlay-panel-${status}`}>
        <p>
          {status === 'gameOver'
            ? 'Game Over'
            : status === 'levelComplete'
              ? 'Level Clear'
              : status === 'won'
                ? 'Victory'
                : status === 'paused'
                  ? 'Paused'
                  : 'Ready'}
        </p>
        <strong>
          {status === 'gameOver'
            ? `Final score ${score}`
            : status === 'levelComplete'
              ? challengeSummary
                ? `${levelName} challenge complete`
                : `${levelName} cleared`
              : status === 'won'
                ? 'All sectors cleared'
                : status === 'paused'
                  ? `Level ${levelIndex + 1}: ${levelName}`
                  : `Clear ${levelCount || 'all'} sectors`}
        </strong>
        {status === 'ready' && (
          <span className="overlay-subtitle">
            {gameTitle}
          </span>
        )}
        {challengeSummary && status === 'levelComplete' && (
          <dl className="summary-grid">
            <div>
              <dt>Hits</dt>
              <dd>{challengeSummary.hits}</dd>
            </div>
            <div>
              <dt>Misses</dt>
              <dd>{challengeSummary.misses}</dd>
            </div>
            <div>
              <dt>Bonus</dt>
              <dd>{challengeSummary.bonusScore}</dd>
            </div>
          </dl>
        )}
        {runSummary && ['gameOver', 'won'].includes(status) && (
          <dl className="summary-grid run-summary">
            <div>
              <dt>Sectors</dt>
              <dd>{runSummary.sectorsCleared}</dd>
            </div>
            <div>
              <dt>Powerups</dt>
              <dd>{runSummary.powerupsCollected}</dd>
            </div>
            <div>
              <dt>No Damage</dt>
              <dd>{runSummary.noDamageSectors}</dd>
            </div>
          </dl>
        )}
        {status === 'won' && (
          <span className="victory-score">Final score {score}</span>
        )}
        {status === 'gameOver' && restartLevelName && (
          <span className="level-countdown">
            Restart from beginning: {restartLevelName}
          </span>
        )}
        {status === 'levelComplete' && typeof levelAdvanceSeconds === 'number' && (
          <span className="level-countdown">
            {practiceMode ? 'Practice complete' : `Next sector in ${levelAdvanceSeconds}`}
          </span>
        )}
        {status === 'levelComplete' && !practiceMode && (
          <button type="button" onClick={onStartNextLevel}>
            Next Level
          </button>
        )}
        {status === 'levelComplete' && practiceMode && (
          <button type="button" onClick={() => onStartPracticeLevel(levelIndex)}>
            Retry
          </button>
        )}
        {status !== 'levelComplete' && (
          <button type="button" onClick={onStartGame}>
            {status === 'ready'
              ? 'Start'
              : status === 'won'
                ? 'Play Again'
                : 'Restart'}
          </button>
        )}
        {onReturnToLibrary && (
          <button
            className="secondary-action"
            type="button"
            onClick={onReturnToLibrary}
          >
            Game Menu
          </button>
        )}
      </div>
    </div>
  );
}

export default GameOverlay;
